export default "__VITE_PUBLIC_ASSET__9e5dac04__"